module.exports = __webpack_public_path__ + "img/img2-2.7cc3c7a1.png";